import _ from 'lodash'
import { formatNumber } from 'core/service/lib/number-format'
import { connect } from 'react-redux'
import { getInvestmentBenefit } from './selectors'
import { getLegalDisclaimerEndDate } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getcoveragePlanStartDate } from 'quick-quote/product-common/coverage-plan/selectors'
import { getSelectedDisplayProductNameThai } from 'quick-quote/product-selection/selectors'
import MESSAGES from 'core/data-model/constants/bi-messages'

export const _InvestmentBenefitTable = ({
  investmentBenefit,
  productName,
  legalDisclaimerEndDate,
  coveragePlanStartDate,
}) => (
  <div className="group example table-no-padding bold-last-child" id="investment-benefit">
    <h3 className="name">
      <span className="example-name" style={{ display: 'none' }}>
        สรุปผลประโยชน์ตามมูลค่ากรมธรรม์
      </span>
      {MESSAGES.INVESTMENT_BENEFITS}
    </h3>
    <div className="dividend-table">
      <table>
        <thead>
          <tr>
            <td rowSpan={2}>{MESSAGES.INVESTMENT_BENEFITS_SUMMARY}</td>
          </tr>
          <tr>
            <td width="20%">
              <div>{MESSAGES.EXAMPLE_1}</div>
              <div>
                {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
                {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_LOW}
              </div>
            </td>
            <td width="20%">
              <div>{MESSAGES.EXAMPLE_2}</div>
              <div>
                {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
                {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_MIDDLE}
              </div>
            </td>
            <td width="20%">
              <div>{MESSAGES.EXAMPLE_3}</div>
              <div>
                {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2}
                {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3} {MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_HIGH}
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          {investmentBenefit.guaranteeBenefits.map((v, k) => (
            <InvestmentBenifitComponent datas={v} key={`guarantee_benefit_${k}`} />
          ))}
        </tbody>
        <tbody>
          {investmentBenefit.nonGuaranteeBenefits.map((v, k) => (
            <InvestmentBenifitComponent datas={v} key={`no_guarantee_benefit_${k}`} />
          ))}
        </tbody>
      </table>
    </div>
    <br />
    <div className="disclaimer">
      <text style={{ color: '#000000' }}>{MESSAGES.NOTE}</text>
      <ul className="dash">
        <li>{MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_1}</li>
        <li>{MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_2}</li>
        <li>{MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_3}</li>
      </ul>
      <br />
      <text style={{ color: '#000000' }}>
        {MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.TITLE}
      </text>
      <ul className="dash">
        <li>{MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_1}</li>
        <li>{MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_2}</li>
        <li>{MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_3}</li>
        <li>{MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_4}</li>
        <li>{MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_5}</li>
        <li>
          {MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6}
          <ol>
            <li>
              {MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_1}
            </li>
            <li>
              {MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_2}
            </li>
          </ol>
        </li>
        <text>
          {MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_3}
        </text>
        <li>
          {MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_7.replace(
            /\n/g,
            ''
          )}
        </li>
      </ul>
      <br />
    </div>
  </div>
)

const InvestmentBenifitComponent = ({ datas }) => {
  if (datas.title === MESSAGES.INVESTMENT_BENEFITS_NONGUARANTEE_MATURITY) {
    return (
      <tr>
        <td>
          3&#41;{' '}
          <text style={{ color: '#2425aa', fontSize: '24px' }}>
            {MESSAGES.TERM_LIFE_BENEFITS_NONGUARANTEE_MATURITY_1}
          </text>
          {MESSAGES.TERM_LIFE_BENEFITS_NONGUARANTEE_MATURITY_2}
        </td>
        {/* <Amount amount={datas.guaranteeValue} /> */}
        {datas.rates.map((v, k) => (_.isNumber(v) ? <Amount amount={v} key={k} /> : <td>{v}</td>))}
      </tr>
    )
  } else if (datas.title === MESSAGES.INVESTMENT_BENEFITS_NONGUARANTEE_TOTAL) {
    return (
      <tr>
        <td>
          {MESSAGES.TERM_LIFE_BENEFITS_NONGUARANTEE_TOTAL_1}{' '}
          <text style={{ color: '#2425aa', fontSize: '24px' }}>{MESSAGES.TERM_LIFE_BENEFITS_NONGUARANTEE_TOTAL_2}</text>
        </td>
        {/* <Amount amount={datas.guaranteeValue} /> */}
        {datas.rates.map((v, k) => (_.isNumber(v) ? <Amount amount={v} key={k} /> : <td>{v}</td>))}
      </tr>
    )
  } else {
    return (
      <tr>
        <td>{datas.title}</td>
        {/* <Amount amount={datas.guaranteeValue} /> */}
        {datas.rates.map((v, k) => (_.isNumber(v) ? <Amount amount={v} key={k} /> : <td>{v}</td>))}
      </tr>
    )
  }
}

const Amount = ({ amount }) => <td>{formatNumber(amount, 0, true)}</td>

const mapStateToProps = (state) => ({
  investmentBenefit: getInvestmentBenefit(state),
  legalDisclaimerEndDate: getLegalDisclaimerEndDate(state),
  coveragePlanStartDate: getcoveragePlanStartDate(state),
  productName: getSelectedDisplayProductNameThai(state),
})
export default connect(mapStateToProps)(_InvestmentBenefitTable)
